import { ref } from '@vue/composition-api';
import { categoryService } from '@/bundles/Category/factory/CategoryServiceFactory';
import { ICategory } from '@/bundles/Category/interfaces';

export function useCategory() {
  const categories = ref<ICategory[]>([]);
  const isLoading = ref(false);
  const total = ref(0);

  async function fetch(params: any[]) {
    isLoading.value = true;

    const { data, total: totalCategories } = await categoryService.list(params);

    categories.value = data;
    total.value = totalCategories;
    isLoading.value = false;
  }

  async function create(payload: ICategory) {
    return await categoryService.create(payload);
  }

  async function edit({
    id,
    payload
  }: {
    id: string | number;
    payload: ICategory;
  }) {
    return await categoryService.edit({ id, payload });
  }

  async function deleteCategory(id: string) {
    await categoryService.delete(id);
  }

  return {
    categories,
    isLoading,
    total,
    fetch,
    create,
    edit,
    deleteCategory
  };
}
